import nam from '../assets/images/members/nam.jpg'
import thinh from '../assets/images/members/thinh.jpg'
import tien from '../assets/images/members/tien.jpg'
import toan from '../assets/images/members/toan.jpg'
import anh from '../assets/images/members/anh.jpg'
import minh from '../assets/images/members/minh.jpg'
import phu from '../assets/images/members/phu.jpg'
export const members = [
  {
    "name": "Duong Hoai Nam",
    "avatar": nam,
    "title": "Mobile/FE Web Developer",
    "summary": "Mobile & Frontend Developer with 3.5 years of experience developing Flutter, React Native, React.js, Next.js applications. Specializing in building real-time applications, integrating payments, optimizing performance and user experience. Experienced in deploying many products from scratch → production (App Store/Google Play)",
    "education": {
      "school": "University of Information Technology - Vietnam National University HCM",
      "degree": "Engineer's Degree in Software Engineering",
      "location": "Ho Chi Minh City, Vietnam",
      "years": "2019 - 2023",
      "gpa": "8.05/10"
    },
    "skills": {
      "mobile": ["Flutter", "React Native", "Flavor", "Deeplink", "biometric", "push notification", "Stripe", "webview", "animation", "socket", "state management", "dependency injection", "performance optimization", "user experience"],
      "frontend": ["HTML", "CSS", "ReactJS", "NextJS", "Material UI", "Ant Design", "Tailwind CSS"],
      "others": ["OOP", "SOLID", "Design Patterns", "Deploy on App Store, Google Play", "Firebase", "Figma", "Jira", "Slack", "Trello"],
      "source_control": ["Github", "Gitlab", "Bitbucket"]
    },
    "languages": [
      { "language": "Vietnamese", "level": "Native" },
      { "language": "English", "level": "Intermediate (working proficiency)" }
    ],
    "experience": [
      {
        "project": "Iyyara",
        "role": "Mobile/FE Web Developer",
        "period": "12/2022 – Present",
        "description": "Iyyara is a dedicated platform for Halal food enthusiasts, allowing users to discover, subscribe, and manage verified Halal options. The admin panel handles restaurant verification, campaigns, and reward management.",
        "responsibilities": [
          "Build and maintain mobile apps (Iyyara, Merchant App) with Flutter",
          "Develop and update admin panel and user web using ReactJS/NextJS",
          "Implement and optimize features such as listing, ScanQR, payment, socket, rewards, and statistics",
          "Deploy and maintain mobile apps on App Store and Google Play",
          "Write technical documentation using Docusaurus, manage tasks on Jira"
        ],
        "technologies": ["Flutter", "ReactJS", "NextJS", "Riverpod", "Firebase", "Stripe", "Socket", "Material UI"]
      },
      {
        "project": "Mark Platform",
        "role": "Mobile Developer / Frontend Developer",
        "period": "07/2022 – Present",
        "description": "A review and discovery platform for interior designers in Singapore. Includes mobile apps (Mark App, Mark Member App) and admin dashboards for management.",
        "responsibilities": [
          "Build and maintain mobile apps (Mark App, Mark Member App) with Flutter",
          "Develop admin panel and business landing pages using ReactJS",
          "Implement UI from Figma, connect APIs, handle logic and performance optimization",
          "Deploy apps to App Store and Google Play"
        ],
        "technologies": ["Flutter", "ReactJS", "NextJS", "Redux Toolkit", "Firebase", "Figma"]
      },
      {
        "project": "CATCheckpoint",
        "role": "Mobile Developer",
        "period": "06/2023 – 08/2023",
        "description": "CATCheckpoint helps manage defect identification and correction in construction projects, improving communication and reducing costs.",
        "responsibilities": [
          "Rebuild Flutter app from old Java source code",
          "Update UI and logic per customer requirements",
          "Fix bugs and handle feedback on Jira"
        ],
        "technologies": ["Flutter", "Firebase", "REST API"]
      },
      {
        "project": "VICT Module",
        "role": "Mobile Developer",
        "period": "06/2023 – 07/2023",
        "description": "Module for VICT's Terminal Management System to handle users and procedures efficiently.",
        "responsibilities": [
          "Design UI on Figma, build and update UI with Flutter",
          "Connect APIs, fix bugs, and handle client logic requests"
        ],
        "technologies": ["Flutter", "Firebase", "Socket"]
      },
      {
        "project": "Ankel Sprain",
        "role": "Mobile Developer",
        "period": "03/2025 – 04/2025",
        "description": "A healthcare app designed to monitor patients’ recovery progress after ankle injuries.",
        "responsibilities": [
          "Build questionnaire logic and handle biometric authentication",
          "Improve app performance and manage push notifications"
        ],
        "technologies": ["Flutter", "Firebase", "Biometric", "Notification"]
      },
      {
        "project": "ClinicalDatas (CDS & My CDS)",
        "role": "Mobile Developer",
        "period": "12/2023 – 01/2024",
        "description": "A healthcare application to track and manage medical records digitally.",
        "responsibilities": [
          "Develop app UI from Figma, connect APIs, integrate authentication and notifications",
          "Fix bugs and handle feedback from clients"
        ],
        "technologies": ["Flutter", "Firebase", "WebView", "Notification"]
      },
      {
        "project": "Am I? Series",
        "role": "Mobile Developer",
        "period": "02/2024 – 06/2024",
        "description": "A series of 5 psychology-related apps helping users assess and manage emotional wellbeing.",
        "responsibilities": [
          "Migrate legacy Java and Objective-C apps to Flutter",
          "Build 5 apps from one unified Flutter source using flavors",
          "Test and fix issues before publishing to stores"
        ],
        "technologies": ["Flutter", "Flavor", "Firebase", "WebView"]
      }
    ]
  },
  {
    "name": "Dang Hai Thinh",
    "avatar": thinh,
    "title": "Software Engineer / Fullstack Developer",
    "summary": `Full-stack developer with over 5 years of hands-on experience in designing, developing, 
                and maintaining scalable web applications using Angular 2+, ReactJS, and ASP.NET (MVC & Core). 
                Strong background in both frontend and backend development with a passion for clean code, modern UI/UX, 
                and performance optimization. Adept at working in Agile environments, collaborating with cross-functional teams, 
                and delivering high-quality products on time.`,
    "education": {
      "school": "University of Information Technology - Vietnam National University HCM",
      "degree": "Engineer's Degree in Software Engineering",
      "location": "Ho Chi Minh City, Vietnam",
      "years": "2019 - 2023",
      "gpa": "7.85/10"
    },
    "skills": {
      "backend": ["NodeJS", "JavaScript", "TypeScript", "ASP.NET Core", "C#", "Python", "LINQ", "RESTful API", "GraphQL", "FastApi", "MSSQL", "MySQL", "PostgreSQL" , "Database design"],
      "frontend": ["HTML", "CSS", "Angular2+", "PrimeNg", "Tailwind CSS"],
      "others": ["OOP", "SOLID", "Design Patterns", "CI/CD on GitLab", "Deploy on Server"],
      "source_control": ["Github", "Gitlab", "Bitbucket"]
    },
    "languages": [
      { "language": "Vietnamese", "level": "Native" },
      { "language": "English", "level": "IELTS 7.5" }
    ],
    "experience": [
      {
        "project": "FrankSalt",
        "role": "Full Stack Developer",
        "period": "10/2020 - 12/2021",
        "description": "FrankSalt is a user management real estate website. It focused on streamlining property listings, client management, and agency operations",
        "responsibilities": [
          "Build interface for system management pages. Assign access right to users",
          "Handle sent and received data, improve UI and UX."
        ],
        "technologies": ["ASP.NET Core", "RESTful API", "GraphQL", "SQL Server", "Angular 14", "Boostrap", "PrimeNg"]
      },
      {
        "project": "MarkApp",
        "role": "Backend Developer",
        "period": "12/2021 - 03/2023",
        "description": "MarkApp is a social platform that enables interior designers to showcase their portfolios and allows homeowners to discover and connect with suitable professionals for home renovation projects.",
        "responsibilities": [
          "Build interface for system management pages.",
          "User dynamic role-based permissions & authentication.",
          "Handle sent and received data, improved UI/UX.",
          "Create and test APIs according to business logic."
        ],
        "technologies": ["Python", "FastApi", "PostgreSQL", "Boostrap"]
      },
      {
        "project": "ISB Scenic",
        "role": "Full Stack Developer",
        "period": "03/2023 - Present",
        "description": "Scenic is a software solution that covers and handles all the business processes involved in the property development business, starting from property / land acquisition, going through the entire property design, planning, development, project management and up to promise of sales and contract management.",
        "responsibilities": [
          "Establish an approach that improved the reporting system of the client, which lowered the time to track their financial analysis by 90%.",
          "Developed custom queries for complex microservices system.",
          "User dynamic role-based permissions & authentication.",
          "Carry out quality assurance tests to discover errors and optimize usability.",
          "Create and test APIs according to business logic."
        ],
        "technologies": ["ASP.NET Core", "RESTful API", "GraphQL", "SQL Server", "Angular 14", "Tailwind Css", "PrimeNg"]
      }
    ]
  },
  {
    "name": "Le Hoang Phu",
    "avatar": phu,
    "title": "Software Engineer / Fullstack Developer",
    "summary": "Full-stack developer with more than 5 years of experience in building scalable web applications across domains including Food & Beverage, Healthcare, and Travel & Booking. Skilled in NodeJS, NestJS, TypeScript, JavaScript, NextJS, ReactJS with a passion for clean architecture, performance optimization, and impactful user experiences.",
    "education": {
      "school": "University of Information Technology - Vietnam National University HCM",
      "degree": "Engineer's Degree in Software Engineering",
      "location": "Ho Chi Minh City, Vietnam",
      "years": "2019 - 2023",
      "gpa": "8.49/10"
    },
    "skills": {
      "backend": ["NodeJS", "NestJS", "JavaScript", "TypeScript", "ASP.NET Core", "C#", "LINQ", "RESTful API", "GraphQL", "MSSQL", "MySQL", "Database design", "MongoDB"],
      "frontend": ["HTML", "CSS", "ReactJS", "NextJS", "Material UI", "Ant Design", "Tailwind CSS"],
      "others": ["OOP", "SOLID", "Design Patterns", "CI/CD on GitLab", "Deploy on Server"],
      "source_control": ["Github", "Gitlab", "Bitbucket"]
    },
    "languages": [
      { "language": "Vietnamese", "level": "Native" },
      { "language": "English", "level": "Intermediate (working proficiency)" }
    ],
    "experience": [
      {
        "project": "Iyyara",
        "role": "Full Stack Developer",
        "period": "02/2020 – Present",
        "description": "Iyyara is an app that verifies halal food options before publishing them in Singapore.",
        "responsibilities": [
          "Built system management dashboards with NextJS and TypeScript",
          "Designed and implemented RESTful APIs (user, campaign, mall, notification, listing, merchant management)",
          "Created unit tests for code reliability"
        ],
        "technologies": ["NextJS", "Material UI", "ExpressJS", "MeteorJS", "Prisma", "MongoDB"]
      },
      {
        "project": "Sprain",
        "role": "Full Stack Developer",
        "period": "03/2023 – 06/2023",
        "description": "Survey application for monitoring patients with ankle injuries post-treatment.",
        "responsibilities": [
          "Built admin panel with NextJS and TypeScript",
          "Implemented APIs for user, survey, notifications, progress, and gifts using NestJS",
          "Created unit tests"
        ],
        "technologies": ["NextJS", "Material UI", "NestJS", "MongoDB"]
      },
      {
        "project": "VICT Module",
        "role": "Front End Developer",
        "period": "10/2021 – 12/2021",
        "description": "User management and procedure execution service in VICT's database system.",
        "responsibilities": [
          "Developed admin panel with ReactJS and TypeScript",
          "Improved UI/UX and data handling"
        ],
        "technologies": ["ReactJS", "Bootstrap"]
      },
      {
        "project": "Auvenir",
        "role": "Front End Developer",
        "period": "02/2022 – 05/2022",
        "description": "Cloud-based audit solution for small to medium-sized engagements in Canada.",
        "responsibilities": [
          "Rechecked logic and updated business of APIs",
          "Created and fixed APIs"
        ],
        "technologies": ["ASP.NET Core", "C#", "MSSQL"]
      },
      {
        "project": "Easy Cambodia",
        "role": "Front End Developer",
        "period": "11/2023 – 06/2024",
        "description": "Web companion for visitors and locals in Cambodia (leisure, business, adventure, tourism).",
        "responsibilities": [
          "Designed and handled interfaces for new displays"
        ],
        "technologies": ["Symfony", "Twig"]
      }
    ]
  },
  {
    "name": "Nguyen Tan Tien",
    "avatar": tien,
    "title": "Software Engineer / Fullstack Developer",
    "summary": "Full-stack developer with over 3 years of hands-on experience in designing, developing, and maintaining scalable web applications using Angular 2+, ReactJS, and ASP.NET (MVC & Core). Strong background in both frontend and backend development with a passion for clean code, modern UI/UX, and performance optimization. Adept at working in Agile environments, collaborating with cross-functional teams, and delivering high-quality products on time.",
    "education": {
      "school": "University of Information Technology - Vietnam National University HCM",
      "degree": "Engineer's Degree in Software Engineering",
      "location": "Ho Chi Minh City, Vietnam",
      "years": "2019 - 2023",
      "gpa": "7.26/10"
    },
    "skills": {
      "backend": ["NodeJS", "NestJS", "JavaScript", "TypeScript", "ASP.NET Core", "C#", "LINQ", "RESTful API", "GraphQL", "MSSQL", "MySQL", "Database design", "MongoDB"],
      "frontend": ["HTML", "CSS", "ReactJS", "NextJS", "Material UI"],
      "others": ["OOP", "SOLID", "Design Patterns", "CI/CD on GitLab", "Deploy on Server"],
      "source_control": ["Github", "Gitlab", "Bitbucket"]
    },
    "languages": [
      { "language": "Vietnamese", "level": "Native" },
      { "language": "English", "level": "Intermediate (working proficiency)" }
    ],
    "experience": [    
      {
        "project": "ISP EPIC - REAPCRM",
        "role": "Front-End Developer",
        "period": "10/2020 – 05/2025",
        "description": "REAPCRM is a comprehensive, web-based management platform designed to streamline and automate the core operations of a real estate agency.",
        "responsibilities": [
          "Build interface for system management pages",
          "Handle send and received data, improve UI and UX",
          " Assign access rights to users"
        ],
        "technologies": [" Angular 16", "Bootstrap", "Postman", "GraphQL"]
      },
      {
        "project": "Iyyara",
        "role": "Full Stack Developer",
        "period": "02/2023 – 06/2023",
        "description": "Iyyara is an app that verifies halal food options before publishing them in Singapore.",
        "responsibilities": [
          "Built system management dashboards with NextJS and TypeScript",
          "Create new APIs as well as fixing existed APIs.",
          "Created unit tests for code reliability"
        ],
        "technologies": ["NextJS", "Material UI", "ExpressJS", "MeteorJS", "Prisma", "MongoDB"]
      },
      {
        "project": "Robinson Pharmacy Inc. - Pharmacy management system",
        "role": " Front-End Developer",
        "period": "01/2023 – 03/2023",
        "description": "The Robinson Pharmacy Management System is a centralized, web-based platform designed to manage the complete operations of the Robinson Pharmacy Inc. chain.",
        "responsibilities": [
          "Developed key front-end components for a web-based platform designed to manage inventory and logistics for a national chain of pharmacies.",
          "Build user-friendly interface with advanced features for medicine information and UI"
        ],
        "technologies": [" Angular 16", "Bootstrap", "Postman"]
      },
      {
        "project": "VICT Module",
        "role": "Front End Developer",
        "period": "10/2020 – 07/2021",
        "description": "User management and procedure execution service in VICT's database system.",
        "responsibilities": [
          "Build interface for system management pages",
          "Handle send and received data, improve UI and UX"
        ],
        "technologies": ["ReactJS", "Bootstrap"]
      },
      {
        "project": "Auvenir",
        "role": "Back End Developer",
        "period": "02/2020 – 05/2020",
        "description": "Cloud-based audit solution for small to medium-sized engagements in Canada.",
        "responsibilities": [
          "Recheck the logic and updates the bussiness of some APIs",
          "Create new APIs as well as fixing existed APIs."
        ],
        "technologies": ["ASP.NET Core", "SQL Server", "MSSQL"]
      }
    ]
  },
  {
    "name": "Nguyen Khanh Toan",
    "avatar": toan,
    "title": "Software Engineer / Fullstack Developer",
    "summary": "Fullstack Developer with over 4 years of experience in developing and maintaining web applications across industries such as Travel, Real Estate, and Business Management. Skilled in PHP (Symfony, Laravel, WordPress) for backend and ReactJS, NextJS, and modern UI frameworks (Bootstrap, Tailwind, Material UI) for frontend. Experienced in database design, CI/CD pipelines, and deploying applications with Docker. Strong focus on building maintainable architectures, enhancing user experience, and collaborating effectively with cross-functional teams.",
    "education": [
      {
        "school": "University of Information Technology - Vietnam National University, HCM",
        "degree": "Engineer's Degree in Software Engineering",
        "location": "Ho Chi Minh City, Vietnam",
        "years": "2019 - 2023",
        "gpa": "7.8/10"
      }, 
      {
        "school": "University of Information Technology - Vietnam National University, HCM",
        "degree": "Master's Degree in Information Sercurity",
        "location": "Ho Chi Minh City, Vietnam",
        "years": "2024 - Present"
      }
    ],
    "skills": {
      "backend": ["JavaScript", "TypeScript", "Database design", "php", "Symfony", "Laravel"],
      "frontend": ["HTML", "CSS", "ReactJS", "NextJS", "Material UI", "Tailwind CSS", "Bootstrap", "Angular", "Twig", "VueJS", "jQuery", "AJAX", "Sass"],
      "others": ["OOP", "SOLID", "Design Patterns", "CI/CD on GitLab", "Deploy on Server", "WordPress"],
      "source_control": ["Github", "Gitlab", "Bitbucket"]
    },
    "languages": [
      { "language": "Vietnamese", "level": "Native" },
      { "language": "English", "level": "Upper-Intermediate" }
    ],
    "experience": [
      {
        "project": "Koeo",
        "role": "Full Stack Developer",
        "period": "03/2024 - Present",
        "description": "Koeo provides professional workflows, management programs and related items for company management services.",
        "responsibilities": [
          "Develop and maintain as a programmer",
          "Working with other developers and project manager",
          "Contributed to the development of features Users management, event management, set up email, ...",
          "Deloy docker"
        ],
        "technologies": ["Php symfony", "Twig", "Bootstrap", "Mysql"]
      },
      {
        "project": "Contestn Co",
        "role": "Full Stack Developer",
        "period": "03/2024 - Present",
        "description": "Contestn Co provides professional workflows, management programs and related items for image contest management services.",
        "responsibilities": [
          "Develop and maintain as a programmer",
          "Working with other developers and project manager",
          "Contributed to the development of features Users management, Event management, vote management, ..."
        ],
        "technologies": ["Php symfony", "Twig", "Bootstrap", "Mysql"]
      },
      {
        "project": "Easy Cambodia",
        "role": "Full Stack Developer",
        "period": "03/2022 - 10/2022",
        "description": "Easy Cambodia is a web and mobile platform designed to enhance travel experiences in Cambodia",
        "responsibilities": [
          "Develop and maintain as a programmer",
          "Working with other developers and discuss directly with customers in weekly meeting."
        ],
        "technologies": ["Php symfony", "Twig", "Bootstrap", "Mysql", "Flutter"]
      },
      {
        "project": "Alliance Malta",
        "role": "Front-end developer",
        "period": "11/2022 - 06/2023",
        "description": "Alliance Malta is a WordPress website designed to advertise real estate properties as well as support property searches and provide real estate information in Malta.",
        "responsibilities": [
          "Develop and maintain as a programmer",
          "Working with other developers and discuss directly with customers in weekly meeting.",
          "Developing wordpress theme to provide UI, property filter, property detail, contact form, ..."
        ],
        "technologies": ["Php wordpress", "Bootstrap", "Mysql"]
      },
      {
        "project": "ISB Website as a Service",
        "role": "Front-end developer",
        "period": "11/2022 - 06/2023",
        "description": "This is a WordPress theme designed to advertise real estate properties as well as support property searches and provide real estate information in Malta. This theme support customizing for multiple website usage",
        "responsibilities": [
          "Develop and maintain as a programmer",
          "Working with other developers and discuss directly with customers in weekly meeting.",
          "Developing wordpress theme to provide UI, property filter, property detail, contact form, ...",
          "Provide customizable option for wordpress theme"
        ],
        "technologies": ["Php wordpress", "Bootstrap", "Mysql"]
      }
    ]
  },
  {
    "name": "Tran Hoang Anh",
    "avatar": anh,
    "title": "Software Engineer / Fullstack Developer",
    "summary": "Experienced Fullstack Developer with over 3 years in software engineering, specializing in both Microsoft and JavaScript ecosystems. Skilled in building scalable backend services and interactive front-end applications. Adept at integrating cloud solutions and applying modern development practices. Proven ability to deliver high-quality software, enhance user experiences, and collaborate effectively with cross-functional teams.",
    // "contact": {
    //   "phone": "0943993238",
    //   "email": "hoanganh18346@gmail.com",
    //   "address": "An Lac, Ho Chi Minh, Vietnam"
    // },
    "education": {
      "school": "University of Information Technology - Vietnam National University HCM",
      "degree": "Bachelor of Software Engineering",
      "location": "Ho Chi Minh City, Vietnam",
      "years": "2019 - 2023",
      "gpa": "7.2/10"
    },
    "skills": {
      "backend": ["C#", "ASP.NET MVC 4/5", "ASP.NET Core", "LINQ", "ASP.NET Web API", "RESTful API", "GraphQL", "JWT", "Claim-based Authorization", "Entity Framework 6", "EF Core (Code-First)", ".NET Core CLI", "MSSQL", "MySQL", "PostgreSQL", "MongoDB", "XML Processing", "AutoMapper", "Hangfire"],
      "frontend": ["ReactJS", "Next.js", "Angular 2+", "Redux Toolkit", "TypeScript", "HTML", "CSS", "Bootstrap", "AJAX", "jQuery", "JavaScript (ES6+)", "JSON"],
      "others": ["OOP", "SOLID Principles", "Design Patterns", "Azure App Service (basic deployment)", "CI/CD", "Jira", "Trello", "Redmine"],
      "source_control": ["GitHub", "GitLab", "Bitbucket"]
    },
    "languages": [
      { "language": "Vietnamese", "level": "Native" },
      { "language": "English", "level": "Intermediate (working proficiency)" }
    ],
    "experience": [
      {
        "company": "TISOHA Software Solutions Co., Ltd.",
        "role": "Software Engineer",
        "period": "October 2021 – Present",
        "description": "Designed and maintained backend services using ASP.NET Core and SQL Server. Developed responsive front-end applications using Angular, Razor Pages, and Next.js. Collaborated with cross-functional teams and implemented CI/CD practices.",
        "responsibilities": [
          "Designed and maintained backend services using ASP.NET Core and SQL Server",
          "Developed responsive front-end applications using Angular, Razor Pages, and Next.js",
          "Collaborated with PMs and designers to align technical solutions with business goals",
          "Implemented CI/CD pipelines and quality assurance practices"
        ],
        "technologies": ["ASP.NET Core", "SQL Server", "Angular", "Razor Pages", "Next.js", "CI/CD"]
      }
    ],
    "projects": [
      {
        "project": "Iyyara",
        "period": "December 2021 – June 2023",
        "description": "A web and mobile platform that verifies halal food options in Singapore.",
        "responsibilities": [
          "Built intuitive interfaces for system management modules",
          "Developed and maintained APIs for campaign, mall, merchant, and notification management",
          "Wrote unit tests to ensure code reliability and maintainability",
          "Applied component-based architecture and custom hooks in ReactJS",
          "Integrated form validation and responsive layouts with Material UI"
        ],
        "technologies": ["ReactJS", "Material UI", "NodeJS", "MeteorJS"]
      },
      {
        "project": "ISB Scenic",
        "period": "October 2021 – Present",
        "description": "A comprehensive property development platform managing all business processes.",
        "responsibilities": [
          "Designed and developed GraphQL and REST APIs ensuring scalability",
          "Implemented high-performance GraphQL resolvers",
          "Built standardized RESTful APIs for legacy and 3rd-party integrations",
          "Optimized SQL queries within microservices architecture",
          "Integrated role-based access control and secure authentication using JWT",
          "Collaborated closely with front-end teams for seamless data flow"
        ],
        "technologies": ["ASP.NET Core", "GraphQL", "REST API", "SQL Server", "Angular 14", "TailwindCSS", "PrimeNG", "AutoMapper", "JWT", "CQRS"]
      },
      {
        "project": "LIBERWOOD",
        "period": "August 2022 – January 2023",
        "description": "Sole Fullstack Developer responsible for the entire software development lifecycle.",
        "responsibilities": [
          "Created user interfaces based on client-provided design specifications",
          "Advised on UX improvements and implemented a custom CMS using Strapi",
          "Managed deployment and conducted final testing for production readiness"
        ],
        "technologies": ["Next.js", "Strapi", "Docker"]
      }
    ]
  },
  {
    "name": "Phan Van Minh",
    "avatar": minh,
    "title": "Mobile Software Engineer",
    "summary": "Mobile Software Engineer with over 2 years of experience, specializing in cross-platform mobile app development using Flutter for iOS and Android. Expertise in building scalable applications, integrating REST APIs, WebSocket, and real-time features, with a focus on performance optimization and clean architecture. Passionate about delivering user-centric solutions, with experience in restaurant POS, logistics, e-commerce, and mental health applications.",
    "education": {
      "school": "University of Information Technology - Vietnam National University HCM",
      "degree": "Engineer's Degree in Software Engineering",
      "location": "Ho Chi Minh City, Vietnam",
      "years": "Not specified",
      "gpa": "8.73/10"
    },
    "skills": {
      "mobile": [
        "Flutter",
        "React Native",
        "Android",
        "Angular",
        "Dart",
        "Java",
        "TypeScript"
      ],
      "backend": [
        ".NET",
        "Express.js",
        "REST API",
        "WebSocket",
        "Firebase"
      ],
      "databases": [
        "MySQL",
        "SQL Server",
        "MongoDB",
        "Hive",
        "SharedPreferences"
      ],
      "others": [
        "Git",
        "Figma",
        "Jira",
        "Trello",
        "Clean Architecture",
        "BLoC",
        "Provider",
        "Riverpod",
        "MQTT",
        "Bluetooth",
        "TCP Socket",
        "Google OCR AI",
        "Viro AR",
        "Mapbox",
        "Redux"
      ]
    },
    "languages": [
      {
        "language": "Vietnamese",
        "level": "Native"
      },
      {
        "language": "English",
        "level": "Intermediate (working proficiency)"
      },
      {
        "language": "German",
        "level": "Basic"
      }
    ],
    "experience": [
      {
        "project": "POS MOI",
        "role": "Mobile Developer",
        "period": "2025",
        "description": "Developed and maintained a cross-platform mobile application for restaurant staff in Germany to manage ordering, billing, and real-time POS operations.",
        "responsibilities": [
          "Built core features for creating, updating, and finalizing customer orders with automatic synchronization between mobile devices and POS terminals.",
          "Integrated Bluetooth and TCP socket communication for receipt printers and POS terminals.",
          "Implemented offline-first functionality using Hive and local caching for uninterrupted operations.",
          "Connected to MySQL database and REST APIs for real-time menu fetching and transaction syncing.",
          "Applied Clean Architecture with BLoC and Repository patterns for maintainability and scalability.",
          "Optimized UI/UX with responsive layouts, custom animations, and multi-language support (German, Vietnamese, English).",
          "Managed device permissions, secure storage, and synchronization logic for high-demand environments."
        ],
        "technologies": [
          "Flutter",
          "MySQL",
          "Hive",
          "SharedPreferences",
          "REST API (Dio)",
          "WebSocket",
          "TCP Socket",
          "Bluetooth",
          "MQTT",
          "Clean Architecture",
          "BLoC Cubit",
          "Provider"
        ]
      },
      {
        "project": "AM I Series",
        "role": "Mobile Developer",
        "period": "2025",
        "description": "Developed a suite of mental health assessment apps to support mood exploration, personalized activities, and well-being tools.",
        "responsibilities": [
          "Migrated legacy native codebases (Java, Objective-C) into a unified Flutter project.",
          "Rebuilt five apps from scratch using Flutter with flavor setup for a single codebase.",
          "Implemented mood assessments, coping strategies, goal-setting, and journaling features.",
          "Optimized code architecture for scalability and reduced technical debt.",
          "Published five apps to Google Play Store and Apple App Store within 2 months."
        ],
        "technologies": [
          "Flutter",
          "Provider",
          "Flavor",
          "Local storage"
        ]
      },
      {
        "project": "CDS and My CDS",
        "role": "Mobile Developer",
        "period": "2025",
        "description": "Developed Auvenir, a cloud-based audit solution for small to medium-sized engagements in Canada.",
        "responsibilities": [
          "Initialized project sources and implemented UI based on Figma designs.",
          "Integrated backend APIs, authentication flows, and Firebase services for push notifications and analytics.",
          "Developed WebView modules for embedded web-based services.",
          "Implemented QR code scanning for healthcare data access and verification."
        ],
        "technologies": [
          "Flutter",
          "WebView",
          "Provider",
          "QR code",
          "Firebase",
          "Local Notification"
        ]
      },
      {
        "project": "Ongo Driver",
        "role": "Mobile Developer",
        "period": "2024",
        "description": "Developed OngoHub, a mobile app for OnGo partner drivers in the Philippines to manage advertising campaigns and automate report submissions.",
        "responsibilities": [
          "Built features for drivers to bid for campaigns by submitting documents.",
          "Implemented AI-powered OCR for extracting job data from Grab report screenshots.",
          "Integrated license plate and dashboard detection using image recognition.",
          "Designed intuitive flows for campaign status tracking and notifications.",
          "Optimized image upload and compression for reliable data sync."
        ],
        "technologies": [
          "Flutter",
          "Google OCR AI",
          "REST API",
          "Provider",
          "Firebase",
          "Local Notification"
        ]
      },
      {
        "project": "Iyyara – Merchant",
        "role": "Mobile Developer",
        "period": "2024",
        "description": "Developed a Flutter-based app for merchants on the Iyyara platform (Singapore) to manage deals, listings, and customer engagement.",
        "responsibilities": [
          "Implemented features for applying deals, managing rewards, and tracking usage history.",
          "Built interfaces for viewing user activities and listing analytics.",
          "Developed modules for responding to customer reviews.",
          "Integrated listing management tools for updating and publishing services.",
          "Collaborated with UI/UX designers for responsive layouts."
        ],
        "technologies": [
          "Flutter",
          "REST API",
          "Riverpod",
          "Firebase Messaging",
          "Notification"
        ]
      },
      {
        "project": "AR Object Detection",
        "role": "Mobile Developer",
        "period": "2023",
        "description": "Developed an AR application for product search within Bach Hoa Xanh supermarket.",
        "responsibilities": [
          "Conducted research for product position identification using phone sensors and GPS.",
          "Implemented product recognition with AR interface for real-time details overlay.",
          "Developed AR-assisted navigation with 2D maps and 3D AR overlays."
        ],
        "technologies": [
          "React Native",
          "Viro AR",
          "Mapbox",
          "Redux",
          "Mobile Sensors"
        ]
      }
    ]
  }
]